module.exports = __webpack_public_path__ + "img/join01.978ebbb6.png";